import React from "react";
import { DOJOOS_MODULES, findDojoOsModule, getModulePhaseLabel } from "../modules/dojoOsModules.js";

/**
 * Readable placeholder for a DojoOS module not yet implemented.
 * @param {object} props
 * @param {string} props.moduleId
 * @param {'fr'|'en'|string} [props.locale]
 * @param {string} [props.testId]
 */
export function DojoOsModulePlaceholder({ moduleId, locale = "fr", testId }) {
  const mod = findDojoOsModule(moduleId);
  const phase = mod?.phase || "future";
  const phaseLabel = getModulePhaseLabel(phase, locale);
  const title = mod ? (locale === "en" ? mod.labelEn : mod.labelFr) : moduleId;
  const description = mod ? (locale === "en" ? mod.descriptionEn : mod.descriptionFr) : "";
  const tid = testId || `dojoos-placeholder-${moduleId}`;

  return (
    <div className="dojoos-module-placeholder" data-testid={tid} data-module-id={moduleId} data-phase={phase}>
      <header className="dojoos-module-placeholder__header">
        <h2 className="dojoos-module-placeholder__title">{title}</h2>
        <span className="dojoos-module-placeholder__phase" data-testid={`${tid}-phase`}>
          {phaseLabel}
        </span>
      </header>
      {description ? <p className="dojoos-module-placeholder__desc">{description}</p> : null}
      <p className="dojoos-module-placeholder__notice">
        {locale === "en"
          ? "[DEMO] Structured module placeholder — no official data invented. Operational features per roadmap."
          : "[DÉMO] Module structuré — aucune donnée officielle inventée. Fonctionnalités opérationnelles selon la feuille de route."}
      </p>
    </div>
  );
}

/**
 * Roadmap grid of DojoOS modules by phase.
 * @param {object} props
 * @param {import('../modules/dojoOsModules.js').DojoOsModule[]} [props.modules]
 * @param {'fr'|'en'|string} [props.locale]
 * @param {string} [props.testId]
 */
export function DojoOsModuleRoadmap({ modules, locale = "fr", testId = "dojoos-module-roadmap" }) {
  const list = modules || DOJOOS_MODULES;
  const phases = ["phase1", "phase2", "future", "advanced"];

  return (
    <div className="dojoos-module-roadmap" data-testid={testId}>
      {phases.map((phase) => {
        const items = list.filter((m) => m.phase === phase);
        if (!items.length) return null;
        return (
          <section key={phase} className="dojoos-module-roadmap__section" data-phase={phase}>
            <h3>{getModulePhaseLabel(phase, locale)}</h3>
            <ul>
              {items.map((m) => (
                <li key={m.id} data-testid={`dojoos-roadmap-${m.id}`}>
                  <span aria-hidden="true">{m.icon}</span> {locale === "en" ? m.labelEn : m.labelFr}
                </li>
              ))}
            </ul>
          </section>
        );
      })}
    </div>
  );
}
